// #region Imports
import { defineComponent, defineAsyncComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-select-field',
    // #endregion
    // #region Mixins
    mixins: [appHost.mixins.form],
    // #endregion
    // #region Components
    components: {
        DxSelectBox: defineAsyncComponent(async () => {
            return (await import(/* webpackChunkName: "dxCommon"*/ 'devextreme-vue/select-box')).DxSelectBox;
        }),
    },
    // #endregion
    // #region Properties
    props: {
        itemSource: {
            type: Object,
            required: false,
            default: null,
        },
        valueExpr: {
            type: String,
            required: false,
            default: ''
        },
        itemTemplate: {
            type: String,
            required: false,
            default: 'item'
        },
        displayExpr: {
            type: String,
            required: false,
            default: ''
        },
        placeholder: {
            type: String,
            required: false,
            default: ''
        },
        searchEnabled: {
            type: Boolean,
            required: false,
            default: false
        },
        mode: {
            type: String,
            required: false,
            default: 'text',
            validValues: ['text', 'password'],
            validator(value) {
                if (!value.length) {
                    return true;
                }
                return ['text', 'password'].includes(value);
            }
        },
        showClearButton: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    // #endregion
    // #region Computed
    computed: {
        _options() {
            return {
                dropDownOptions: {
                    minWidth: 300
                }
            };
        }
    },
    // #endregion
    // #region Methodes
    methods: {
        onEnterKey(event) {
            this.$emit('EnterKey', event);
        },
        evalDisplayName(item) {
            return utils.evalExpression(item, this.displayExpr);
        },
        evalValue(item) {
            return utils.evalExpression(item, this.valueExpr);
        },
    }
    // #endregion
});
// #endregion
